import { css } from '@emotion/css';
import { ColorConstant, Font } from 'src/styles';

export const mailOpenIcon = css`
  ${Font.h2}
  color: ${ColorConstant.GREEN6};
`;
